module.exports = __webpack_public_path__ + "static/media/logo_croped.18366fc6.png";